import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import heroBg from "../../assets/bochhero.jpg"; // Update path as needed
import { FaLongArrowAltRight } from "react-icons/fa";
import { IoPlayCircle } from "react-icons/io5";
import { RiMoneyDollarCircleLine } from "react-icons/ri";
import { motion } from "motion/react"
function Hero() {
  return (
    <section
      className="hero d-flex align-items-center" id='hero'
      style={{
        backgroundImage: `linear-gradient(
      180deg,
    rgba(0, 0, 0, 0.55),
      rgba(0, 0, 0, 0.55)
    ),url(${heroBg})`,
        backgroundSize: "cover",
        backgroundRepeat: "no-repeat",
        backgroundPosition: "center center",
        minHeight: "100vh",
        width: "100%",
        position: "relative",
      }}
    >
      <Container>
      
        <Row className="align-items-center g-5"   initial={{ opacity: 0, y: 40 }}
  >
          {/* Left Column */}
          <Col xs={12} lg={6} className="leftlgimg">
            <div className="eyebrow" style={{color:'var(--gold)'}}>
              Regulation D — Rule 506(c) Offering
            </div>

            <motion.h1 style={{ fontSize: '3.5rem' }}>
      <motion.span
    initial={{ opacity: 0, y: 40 }}
    whileInView={{ opacity: 1, y: 0 }}
    transition={{ duration: 0.8 }}
    viewport={{ once: true }}
    style={{ display: "block" }}
  >
              Offering Creative
              <br />
              <span style={{color:'var(--gold)'}}>Investments<br/> for the Future</span>
               </motion.span>
            </motion.h1>
 
            <motion.p className="hero-copy">
                    <motion.span
    initial={{ opacity: 0, y: 40 }}
    whileInView={{ opacity: 1, y: 0 }}
    transition={{ duration: 0.8 }}
    viewport={{ once: true }}
    style={{ display: "block" }}
  > 
              Transforming billboard assets into investor returns - with speed, transparency, and scale.
                </motion.span> 
            </motion.p>

            <div className="hero-actions d-flex flex-wrap gap-3">
              <a href="#terms" className="btn btn-lg site-box-shadow" style={{color:"var(--white)", backgroundColor:'var(--gold)'}}>
                Offering Terms <FaLongArrowAltRight />
              </a>
              <a href="#reasons" className="btn btn-lg btn-secondary site-box-shadow" style={{backgroundColor:'transparent'}}>
                Why Invest <IoPlayCircle />
              </a>

              <a href="signup" className="btn btn-lg site-box-shadow"style={{color:"var(--white)", backgroundColor:'var(--gold)'}}>
                Invest Now <RiMoneyDollarCircleLine />
              </a>
            </div>
          </Col>

          {/* Right Column */}
          <Col
            xs={12}
            lg={6}
            className="narrative-card asset-dossier-card fade-up leftlgimg"
          >
                      {/* <div className="hero-stats fade-up rounded"
                   
                      >
              <div className="stat-box">
                <div className="stat-value">$200M</div>
                <div className="stat-label" style={{color:"var(--white)"}}>Maximum Offering</div>
              </div>

              <div className="stat-box">
                <div className="stat-value">$50K</div>
                <div className="stat-label" style={{color:"var(--white)"}}>Minimum Investment</div>
              </div>

              <div className="stat-box" >
                <div className="stat-value">8–12%</div>
                <div className="stat-label" style={{color:"var(--white)"}}>Target Annual Return</div>
              </div>
            </div>

            <div className="raise-wrap fade-up rounded">
              <div className="raise-head">
                <span>Capital Raised</span>
                <strong>$47.3M</strong>
              </div>

              <div className="progress-track">
                <div
                  className="progress-bar"
                  role="progressbar"
                  aria-valuenow={23.65}
                  aria-valuemin={0}
                  aria-valuemax={100}
                  style={{ width: "23.65%" }}
                />
              </div>

              <div className="raise-foot">
                <span>23.65% of $200M maximum</span>
                <span>183 Accredited Investors</span>
              </div>
            </div> */}
            <div className="hero-building rounded">
                <div className="hero-stats fade-up rounded"
                   
                      >
              <div className="stat-box">
                <div className="stat-value">$6M</div>
                <div className="stat-label" style={{color:"var(--white)"}}>Maximum Offering</div>
              </div>

              <div className="stat-box">
                <div className="stat-value">$3M</div>
                <div className="stat-label" style={{color:"var(--white)"}}>Target Offering</div>
              </div>

              <div className="stat-box" >
                <div className="stat-value">$100K</div>
                <div className="stat-label" style={{color:"var(--white)"}}>Minimum Investment</div>
              </div>
            </div>

            <div className="raise-wrap fade-up rounded ">
              <div className="raise-head">
                <span>Capital Raised</span>
                <strong>$3M</strong>
              </div>

              <div className="progress-track">
                <div
                  className="progress-bar"
                  role="progressbar"
                  aria-valuenow={23.65}
                  aria-valuemin={0}
                  aria-valuemax={100}
                  style={{ width: "50%" }}
                />
              </div>

              <div className="raise-foot">
                <span>50% of $6M maximum</span>
                <span>250 Accredited Investors</span>
              </div>
            </div>
          {/* <div className="hero-building-badge text-white site-box-shadow">Let Us Make Your Vision a Reality</div> */}
        </div>
          </Col>
        </Row>
        
      </Container>
    </section>
  );
}

export default Hero;